<template>
	<AssemblyLayout :assembly="assembly" :subtitle="trans('general.edit')">
		<template #actions>
			<a :href="route('association.assemblies.report.show', assembly.id)">
				<SecondaryButton :color="Color.Purple">
					<i class="fa-solid fa-download mr-2"/>
					{{ trans('assemblies.download') }}
				</SecondaryButton>
			</a>
			<PrimaryButton :color="Color.Green" @click.stop="update">
				<i class="fa-solid fa-check"/>
			</PrimaryButton>
		</template>
		<div class="flex flex-col items-stretch md:flex-row md:items-end gap-3">
			<LabeledObject required full>
				<template #label>{{ trans('assemblies.nomination_starts_at') }}</template>
				<IconDateTimeInput v-model="assembly.nomination_starts_at" :min="min" icon-class="fa-solid fa-hourglass-start" full/>
			</LabeledObject>
			<LabeledObject required full>
				<template #label>{{ trans('assemblies.nomination_ends_at') }}</template>
				<IconDateTimeInput v-model="assembly.nomination_ends_at" :min="assembly.nomination_starts_at" icon-class="fa-solid fa-hourglass-end" full/>
			</LabeledObject>
			<LabeledObject required full>
				<template #label>{{ trans('assemblies.meeting_url') }}</template>
				<input v-model="assembly.meeting.link" type="url">
			</LabeledObject>
			<Switch v-model="assembly.active" :label="trans('general.active')"/>
		</div>
		<Card :title="trans('assemblies.seats')">
			<div class="grid grid-cols-1 md:grid-cols-2 gap-3">
				<LabeledObject v-for="collegeZone in CollegeZone" required full>
					<template #label>{{ trans(`colleges.${collegeZone}`) }}</template>
					<NumberInput v-model="assembly[`${collegeZone}_seats`]"/>
				</LabeledObject>
			</div>
		</Card>
		<Card v-if="!assembly.incoming_board.active" :title="trans('general.danger')" danger>
			<p v-for="description in trans('assemblies.close.descriptions')">{{ description }}</p>
			<template #footer>
				<Link :as="PrimaryButton" :color="Color.Red" :href="route('association.assemblies.finalization.index', assembly.id)">
					<i class="fa-solid fa-door-open mr-2"/>
					{{ trans('assemblies.close.button') }}
				</Link>
			</template>
		</Card>
	</AssemblyLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import dayjs from 'dayjs'
import {route} from 'ziggy-js'
import {ref, type Ref} from 'vue'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Card from '@/Components/UI/Cards/Card.vue'
import {CollegeZone} from '@/Types/Enums/CollegeZone'
import Switch from '@/Components/UI/Switches/Switch.vue'
import AssemblyLayout from '@/Layouts/AssemblyLayout.vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import NumberInput from '@/Components/UI/Inputs/NumberInput.vue'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {type Assembly} from '@/Types/Association/Assemblies/Assembly'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'
import IconDateTimeInput from '@/Components/UI/Inputs/IconDateTimeInput.vue'

const props = defineProps<{
	assembly:Assembly,
	selectedTab:string,
}>()

const assembly:Ref<Assembly> = ref(props.assembly)
const working:Ref<boolean> = ref(false)
const min = dayjs().format('YYYY-MM-DD')

function update():void{
	if(!working.value){
		working.value = true
		showInfo(trans('general.updating'))
		axios.patch(route('association.assemblies.update', assembly.value.id), assembly.value).then(() => {
			showSuccess(trans('general.updated'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>